/* ag-ux-r5-Q6-PAGES.js — R5 lane Q6-PAGES · progressive enhancement for the
   10 car-model guide pages (templates/page.json).
   WHAT: makes each fitment-table row's product cell tappable by wrapping it in
   a link to that product. The href comes ONLY from product links that already
   exist in the page content ("Shop …" box written by the owner) matched on
   exact normalised title text — no invented URLs, no invented products.
   If no matching link exists, the cell stays plain text (graceful no-op).
   Runs deferred; keyboard users get a real <a>, focusable and underlined on
   focus-visible per the a11y contract. */
(function () {
  'use strict';
  var prose = document.querySelector('body.template-page .prose');
  if (!prose) return;
  var map = {};
  prose.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
    var t = (a.textContent || '').replace(/\s+/g, ' ').trim();
    if (t && !map[t]) map[t] = a.href;
  });
  prose.querySelectorAll('table tbody tr').forEach(function (tr) {
    var td = tr.querySelector('td');
    if (!td || td.querySelector('a')) return;
    var key = (td.textContent || '').replace(/\s+/g, ' ').trim();
    var href = map[key];
    if (!href) return;
    var a = document.createElement('a');
    a.href = href;
    a.className = 'agpg-tlink';
    while (td.firstChild) a.appendChild(td.firstChild);
    td.appendChild(a);
  });
})();
